import { useCallback } from "react";
import { useMenuPrincipal } from "../../../../../../service/app/providers/menu-principal-provider";
import { useThemeQueries } from "../../../../../../theme";
import { ButtonPrivateHeader } from "../../../../../components/controles/buttons";
import { PrivatePageHeader } from "../../../../../components/headers/header-private-page"
import { MenuIcon } from "../../../../../components/icons";

export const LojasHeader = () => {

   const { abrirMenu } = useMenuPrincipal()
   const { isMobile } = useThemeQueries()

   const leftArea = useCallback(
      () =>
         isMobile ? (
            <ButtonPrivateHeader
               icon={<MenuIcon tipo="PRIVATE_HEADER"></MenuIcon>}
               tooltip="Menu"
               onClick={abrirMenu}
            ></ButtonPrivateHeader>
         ) : null,
      [isMobile, abrirMenu]
   );

   return (
      <>
         <PrivatePageHeader
            title="Dados de Contrato"
            leftArea={leftArea()}
         />
      </>
   )
}